export default "__VITE_ASSET__BWQXA2c1__"